module.exports = __webpack_public_path__ + "static/tslil-artist-profile-e10cefb348f7898965515128f21fcab2.jpg";